export enum AttachmentEntityType {
    Order = 1,
    Job = 2,
    Container = 3,
    WorkOrder = 4,
    ContainerJobItem = 5,
}